import {
  SET_SELECTED_TERMINAL,
  SET_TRANSACTION_DATES,
  SET_SELECTED_TRANSACTION_TYPES,
  SET_TRANSACTION_VOLUME_DATES,
  SET_TRANSACTION_STATS_TYPES,
  GET_TERMINAL_SUMMARY,
  GET_TERMINAL_SUMMARY_SUCCESS,
  GET_TERMINAL_SUMMARY_FAIL,
  GET_TERMINAL_ACTIVITY,
  GET_TERMINAL_ACTIVITY_SUCCESS,
  GET_TERMINAL_ACTIVITY_FAIL,
  GET_TRANSACTION_TYPE_STATS,
  GET_TRANSACTION_TYPE_STATS_SUCCESS,
  GET_TRANSACTION_TYPE_STATS_FAIL,
  GET_TRANSACTION_BREAKDOWN,
  GET_TRANSACTION_BREAKDOWN_SUCCESS,
  GET_TRANSACTION_BREAKDOWN_FAIL,
  SET_CURRENT_AGENT,
  GET_TRANSACTION_STATUS_STATS,
  GET_TRANSACTION_STATUS_STATS_SUCCESS,
  GET_TRANSACTION_STATUS_STATS_FAIL,
  GET_REGION_STATS,
  GET_REGION_STATS_SUCCESS,
  GET_REGION_STATS_FAIL,
} from "redux/types/dashboard/terminalDashboardTypes";

const initialState = {
  userType: "AGENT", //initial is logged in userType, but aggregator can switch this to agent or aggregator
  agentId: undefined, //initial is logged in user's agentId, but aggregator can switch
  selectedTerminal: undefined,
  selectedTransactionTypes: [],

  dates: {
    dateTo: "",
    dateFrom: "",
  },

  //11.1
  terminalSummary: {
    //First summary cards
    data: {},
    loading: false,
  },

  //11.2
  terminalActivity: {
    //Second summary cards
    data: {},
    loading: false,
  },

  // 12.1
  transactionType: {
    loading: false,
    data: {},
  },

  //12.2
  transactionTypeStats: {
    data: [],
    loading: false,
  },

  // 12.3
  regionStats: {
    loading: false,
    data: {},
  },

  //transaction success rate (12.4)
  transactionStatus: {
    loading: false,
    data: {},
  },
  //multiple bar chart of varying colors (12.5)
  transactionStatsBreakdown: {
    selectedTransactionTypes: [],
    dates: {
      dateTo: "",
      dateFrom: "",
    },
    data: {},
    loading: false,
  },
};

const terminalDashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SELECTED_TERMINAL:
      return {
        ...state,
        selectedTerminal: payload,
      };

    case SET_SELECTED_TRANSACTION_TYPES:
      return {
        ...state,
        selectedTransactionTypes: payload,
      };

    case SET_TRANSACTION_DATES: {
      return {
        ...state,
        dates: {
          ...state.dates,
          [payload.dateType]: payload.value,
        },
      };
    }

    case SET_TRANSACTION_VOLUME_DATES: {
      return {
        ...state,
        transactionStatsBreakdown: {
          ...state.transactionStatsBreakdown,
          dates: {
            ...state.transactionStatsBreakdown.dates,
            [payload.dateType]: payload.value,
          },
        },
      };
    }

    case SET_TRANSACTION_STATS_TYPES: {
      return {
        ...state,
        transactionStatsBreakdown: {
          ...state.transactionStatsBreakdown,
          selectedTransactionTypes: payload,
        },
      };
    }

    case GET_TERMINAL_SUMMARY: {
      return {
        ...state,
        terminalSummary: {
          ...state.terminalSummary,
          loading: true,
        },
      };
    }

    case GET_TERMINAL_SUMMARY_SUCCESS: {
      return {
        ...state,
        terminalSummary: {
          ...state.terminalSummary,
          loading: false,
          data: payload,
        },
      };
    }

    case GET_TERMINAL_SUMMARY_FAIL: {
      return {
        ...state,
        terminalSummary: {
          ...state.terminalSummary,
          loading: false,
        },
      };
    }

    case GET_TERMINAL_ACTIVITY: {
      return {
        ...state,
        terminalActivity: {
          ...state.terminalActivity,
          loading: true,
        },
      };
    }

    case GET_TERMINAL_ACTIVITY_SUCCESS: {
      return {
        ...state,
        terminalActivity: {
          ...state.terminalActivity,
          loading: false,
          data: payload,
        },
      };
    }

    case GET_TERMINAL_ACTIVITY_FAIL: {
      return {
        ...state,
        terminalActivity: {
          ...state.terminalActivity,
          loading: false,
        },
      };
    }

    case GET_TRANSACTION_TYPE_STATS: {
      return {
        ...state,
        transactionTypeStats: {
          ...state.transactionTypeStats,
          loading: true,
        },
      };
    }

    case GET_TRANSACTION_TYPE_STATS_SUCCESS: {
      return {
        ...state,
        transactionTypeStats: {
          ...state.transactionTypeStats,
          data: payload,
          loading: false,
        },
      };
    }

    case GET_TRANSACTION_TYPE_STATS_FAIL: {
      return {
        ...state,
        transactionTypeStats: {
          ...state.transactionTypeStats,
          loading: false,
        },
      };
    }

    case GET_TRANSACTION_BREAKDOWN: {
      return {
        ...state,
        transactionStatsBreakdown: {
          ...state.transactionStatsBreakdown,
          loading: true,
        },
      };
    }

    case GET_TRANSACTION_BREAKDOWN_SUCCESS: {
      return {
        ...state,
        transactionStatsBreakdown: {
          ...state.transactionStatsBreakdown,
          data: payload,
          loading: false,
        },
      };
    }

    case GET_TRANSACTION_BREAKDOWN_FAIL: {
      return {
        ...state,
        transactionStatsBreakdown: {
          ...state.transactionStatsBreakdown,
          loading: false,
        },
      };
    }

    case GET_TRANSACTION_STATUS_STATS: {
      return {
        ...state,
        transactionStatus: {
          ...state.transactionStatus,
          loading: true,
        },
      };
    }

    case GET_TRANSACTION_STATUS_STATS_SUCCESS: {
      return {
        ...state,
        transactionStatus: {
          ...state.transactionStatus,
          data: payload,
          loading: false,
        },
      };
    }

    case GET_TRANSACTION_STATUS_STATS_FAIL: {
      return {
        ...state,
        transactionStatus: {
          ...state.transactionStatus,
          loading: false,
        },
      };
    }

    case GET_REGION_STATS: {
      return {
        ...state,
        regionStats: {
          ...state.regionStats,
          loading: true,
        },
      };
    }

    case GET_REGION_STATS_SUCCESS: {
      return {
        ...state,
        regionStats: {
          ...state.regionStats,
          data: payload,
          loading: false,
        },
      };
    }

    case GET_REGION_STATS_FAIL: {
      return {
        ...state,
        regionStats: {
          ...state.regionStats,
          loading: false,
        },
      };
    }

    case SET_CURRENT_AGENT: {
      return {
        ...state,
        agentId: payload,
      };
    }

    default:
      return state;
  }
};

export default terminalDashboardReducer;
